import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("PurchaseStore");

const urls = {
  myDeals: `/bnpl/deal/merchant/my-deals`,
  myDealsWithQuery: (query) => `/bnpl/deal/merchant/my-deals?${query}`,
  deal: (id) => `/bnpl/deal/merchant/${id}`,
  refund: (id) => `/bnpl/deal/merchant/${id}/refund`,
  // deal: (id) => `/bnpl/purchase/deal/${id}`,
};

const initState = () => {
  return {
    deals: [],
    deal: {},
  };
};

const actions = {
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let url = urls.myDeals;
      if (query) {
        url = urls.myDealsWithQuery(query);
      }
      let { data } = await axios.get(url);
      commit("saveDeals", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.deal(id));
      commit("saveDeal", { data: data, id: id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  refund: async ({}, id) => {
    try {
      const axios = await network.connection();
      await axios.patch(urls.refund(id));
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveDeals: (state, data) => {
    Vue.set(state, "deals", data);
  },
  saveDeal: (state, { data, id }) => {
    Vue.set(state.deal, id, data);
  },
};

const getters = {
  list: (state) => {
    return state.deals;
  },
  get: (state) => (id) => {
    return state.deal[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
